import React from "react";
import BaseComponent from "meta/features/base-component";
import Cookie from "js-cookie";
import moment from "moment";

function formatFacilitiesList(list) {
  if (list.length === 0) {
    return "none";
  } else {
    // Create copy of the list to avoid 'freed script' issue in IE
    return Array.from(list).join(", ");
  }
}

class UserInfo extends BaseComponent {
  constructor() {
    super();

    this.state = {
      displayIpInfo: false,
    };
  }

  componentDidMount() {
    let updateTimers = () => {
      let offsetMins = Cookie.get("TZServerOffsetMins") * 60 * 1000;
      let validTill =
        parseInt(Cookie.get("LastActivity")) +
        parseInt(Cookie.get("LastActivityInt"));

      let logoutTime = new Date(validTill + offsetMins);
      let currentTime = new Date(new Date().getTime() + offsetMins);
      this.setState({
        currentTime: moment(currentTime).format("MM/DD/YYYY HH:mm:ss"),
        logoutTime: moment(logoutTime).format("MM/DD/YYYY HH:mm:ss"),
      });
    };

    updateTimers();
    setInterval(() => updateTimers(), 1000);
  }

  showOrHideMoreInfo = () => {
    this.setState({ displayIpInfo: !this.state.displayIpInfo });
  };

  ChangeNS = () => {
    DialogManager.GlobalDialog.showIframe(
      "Assigned NS",
      "eMAR/eMAR_ChangeNS.aspx",
      "",
      350,
      140
    );
  };

  changePrinterGroup = () => {
    DialogManager.GlobalDialog.showIframe(
      "Printer group",
      "eMAR/eMAR_ChangePrinterGroup.aspx",
      "",
      350,
      140
    );
  };

  render() {
    let { user } = this.props;
    let { logoutTime, currentTime } = this.state;

    return (
      <React.Fragment>
        <h3>{user.FullName}</h3>
        <div className="user-id">
          {user.UserOpId}
          <span
            id="moreInfoShowHide"
            className="more-info-showHide"
            onClick={this.showOrHideMoreInfo}
          >
            {" "}
            {this.state.displayIpInfo ? "<<" : ">>"}{" "}
          </span>
        </div>
        <div
          id="moreInfo"
          className="more-info"
          style={{ display: this.state.displayIpInfo ? "block" : "none" }}
        >
          <span>
            Last login was performed from IP: {user.LastLoginIP}
            <br />
            <br />
            If you are suspecting your credentials are used by an unauthorized
            person, please report it to your application manager
          </span>
        </div>
        <h4>Location</h4>
        <dl>
          <div className="key-value-group">
            <dt>System time</dt>
            <dd>{currentTime}</dd>
          </div>
          <div className="key-value-group">
            <dt>Auto logout at</dt>
            <dd>{logoutTime}</dd>
          </div>
          <div className="key-value-group">
            <dt>
              {user.UserDocID == 0 ? (
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => this.ChangeNS()}
                >
                  NS
                </a>
              ) : (
                "NS"
              )}
            </dt>
            <dd>{user.AssignedNS}</dd>
          </div>
          <div className="key-value-group">
            <dt>
              <a
                style={{ cursor: "pointer" }}
                onClick={() => this.changePrinterGroup()}
              >
                Printer group
              </a>
            </dt>
            <dd>{user.AssignedPrinterGroup}</dd>
          </div>
          <div className="key-value-group">
            <dt>Workstation</dt>
            <dd>
              {user.WorkstationName} at {user.WorkstationLocation}
            </dd>
          </div>
        </dl>
        <h4>Facility access</h4>
        <dl>
          <div className="key-value-group">
            <dt>Full</dt>
            <dd>{formatFacilitiesList(user.FullAccessFacilitiesList)}</dd>
          </div>
          <div className="key-value-group">
            <dt>Readonly</dt>
            <dd>{formatFacilitiesList(user.ReadonlyAccessFacilitiesList)}</dd>
          </div>
        </dl>
        {/* IMPLEMENT_WITH_POSID_IMPLEMENTATION positive ID goes here */}
      </React.Fragment>
    );
  }
}

export default UserInfo;
